type Listener = () => void;
type ZoomListener = (zoom: number) => void;

const initialViewListeners = new Set<Listener>();
const zoomListeners = new Set<ZoomListener>();

/** Subscribe to "fly to initial view" commands. Returns unsubscribe fn. */
export function onFlyToInitialView(fn: Listener): () => void {
  initialViewListeners.add(fn);
  return () => initialViewListeners.delete(fn);
}

/** Emit a "fly to initial view" command. */
export function flyToInitialView(): void {
  for (const fn of initialViewListeners) fn();
}

/** Subscribe to "fly to zoom" commands. Returns unsubscribe fn. */
export function onFlyToZoom(fn: ZoomListener): () => void {
  zoomListeners.add(fn);
  return () => zoomListeners.delete(fn);
}

/** Emit a "fly to zoom level" command. */
export function flyToZoom(zoom: number): void {
  for (const fn of zoomListeners) fn(zoom);
}
